import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GMB_STATUS} from '@boxx/gmb-core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-gmb-success',
  templateUrl: './gmb-success.page.html',
  styleUrls: ['./gmb-success.page.scss'],
})
export class GmbSuccessPage implements OnInit {
  gmbStatus: GMB_STATUS = 'VERIFIED';
  gmbData: any;
  destroyed$ = new Subject<boolean>();
  translations: any;
  step = 1;

  constructor(
    private translate: TranslateService,
    private modalCtrl: ModalController,
  ) {
    this.translate
      .get(['BUSINESS_FORMS', 'ONBOARDING_MODULE'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t) => (this.translations = t));
  }

  ngOnInit() {}

  finish() {
    this.modalCtrl.dismiss();
  }
}
